import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { logError } from "@faire/web--source/common/logging";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { useEffect, useState } from "react";
export var useScriptCheck = function(param) {
    var isScriptLoaded = param.isScriptLoaded, loadScript = param.loadScript, provider = param.provider;
    // Script load error => Should trigger an error message
    var _useState = _sliced_to_array(useState(false), 2), hasScriptError = _useState[0], setHasScriptError = _useState[1];
    // Script load check
    var isSSR = useIsSSR();
    var _useState1 = _sliced_to_array(useState(!isSSR && !isScriptLoaded()), 2), isScriptLoading = _useState1[0], setIsScriptLoading = _useState1[1];
    var _useState2 = _sliced_to_array(useState(!isSSR), 2), didInit = _useState2[0], setDidInit = _useState2[1];
    useEffect(function() {
        if (!didInit && !isSSR) {
            // In SSR, wait until after hydration to load the script.
            setIsScriptLoading(!isScriptLoaded());
            setDidInit(true);
        }
    }, [
        didInit,
        isSSR,
        isScriptLoaded
    ]);
    // Load script if needed
    useEffect(function() {
        if (isScriptLoading) {
            loadScript().then(function() {
                return setIsScriptLoading(false);
            }).catch(function(error) {
                setHasScriptError(true);
                setIsScriptLoading(false);
                logError(error, {
                    tags: {
                        signInType: "SSO",
                        code: "script_load_failed",
                        provider: provider
                    }
                });
            });
        }
    }, [
        isScriptLoading,
        isScriptLoaded,
        loadScript,
        provider
    ]);
    return {
        isScriptLoading: isScriptLoading,
        hasScriptError: hasScriptError
    };
};
